import type { Url } from 'next/dist/shared/lib/router/router'
import { allRoutesManifest as routeManifest } from './routeManifest'

function normaliseUrl(url: string) {
  let url_ = url.split('?')[0]!
  try {
    const u = new URL(url)
    url_ = u.pathname
  } catch {}
  return url_
}

function findInternalRoute(path: string) {
  const matches = routeManifest.filter(({ regex }) => regex.test(path))
  if (!matches.length) return
  if (matches.length === 1) return matches[0]
  const pathSegments = path.split('/')
  let maxMatching = -1
  let bestMatch: (typeof matches)[number] | undefined
  for (const match of matches) {
    const segments = match.route.split('/')
    let matching = 0
    for (let i = 0; i < pathSegments.length; i++) {
      const segment = segments[i]
      matching += +(segment === pathSegments[i])
    }
    if (matching <= maxMatching) continue
    maxMatching = matching
    bestMatch = match
  }
  return bestMatch!
}

export function urlToString(url: Url) {
  if (typeof url === 'string') return url
  return `${url.pathname}${url.hash ? `#${url.hash}` : ''}`
}

/**
 * Checks if the provided URL matches any of the internal paths
 * @param url - The URL to check
 * @returns true if the URL matches an internal path, false otherwise
 */

export function isInternalUrl(url: Url): boolean {
  return !!getRoute(url)
}

export function getRoute(url: Url | undefined): string | undefined {
  if (!url) return
  const strUrl = urlToString(url)
  if (!strUrl) return
  if (strUrl.startsWith('javascript:')) return
  if (strUrl) if (strUrl.startsWith('#')) return
  // Normalize URL by stripping query string
  let normalizedUrl = normaliseUrl(strUrl)
  normalizedUrl = normalizedUrl.split(/[#\?]/)[0]!
  return findInternalRoute(normalizedUrl)?.route
}
